module.exports = __webpack_public_path__ + "static/award-tucows-53e573def9edc41a27415a0ba3112222.png";